// extracted by mini-css-extract-plugin
export default {"savedIcon":"bemftoQh6ceyqsfc7Qky","disabled":"LbOcpSAQL0cnAV8_OIzH","tableScroll":"TCFSlipqVtMcm9OuyN08"};